import Header from "@/components/Header";
import NewYearCard from "@/components/NewYearCard";
import Footer from "@/components/Footer";

const NewYearGreeting = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <div className="flex-1 pt-20">
        <NewYearCard />
      </div>
      <Footer />
    </div>
  );
};

export default NewYearGreeting;
